import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
import { OAuthExternalCallbackPage } from "src/features/integrations/sources/oauth/OAuthExternalCallbackPage.js";

export const DatevExternalCallbackPage = () => {
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();
	const isAuthenticated =
		(searchParams.get("integrationIds") !== null ||
			searchParams.get("integrationId") !== null) &&
		searchParams.get("selected") === "1";

	if (isAuthenticated) {
		return (
			<div className="flex min-h-screen items-center justify-center bg-gray-50 p-6 text-center text-base text-gray-700">
				<div className="rounded-lg bg-white p-6 shadow-xs">
					{t("Integration authenticated. You can now close this page.")}
				</div>
			</div>
		);
	}

	return <OAuthExternalCallbackPage />;
};
